import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import StyledButton from "../../../../common/models/Button";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { he } from "date-fns/locale";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "900px",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
      height: "30px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "2px",
  },

  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(4),
  },

  backButton: {
    backgroundColor: "#555",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  iconBtn: {
    padding: "4px",
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 8,
  },
  resetChangesButton: {
    border: "1px solid #000000",
    color: "#000000",
    fontWeight: 600,
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    marginTop: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  saveButton: {
    backgroundColor: "#f26522",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#d4551a",
    },
  },
}));

const UOMTab = (props) => {
  const { featuresAccess, sponsorId } = props;
  const classes = useStyles();
  const [uoms, setUoms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isUpdated, setIsUpdated] = useState(false);
  const [savingStates, setSavingStates] = useState({});

  const [errorMessage, setErrorMessage] = useState("");
  
  // Get edit access from featuresAccess
  const canEdit = featuresAccess?.editSponsorNetworkDetails ?? false;

  const dispatch = (action) => {
    if (action.type === "OPEN_BACKDROP") {
      //console.log("Opening backdrop");
    } else if (action.type === "DESTROY_BACKDROP") {
      //console.log("Closing backdrop");
    }
  };

  const fetchUOMs = async () => {
    setError(null);
    setLoading(true);
    dispatch({ type: "OPEN_BACKDROP" });
    
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllUOMs/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;

      //console.log("API UOM Data:", data);

      const list = data.productUOMsList || [];
      //console.log(list, "UOM List");
      if (data?.status === true || data?.status === "true") {
        const formatted = list.map((item, index) => ({
          id: item.uomID,
          uom: item.uom,
          selected: !!item.activated,
          isNew: false,
          uomType: item.uomType,
          lastUpdatedBy: item.lastUpdatedBy,
        }));
        //console.log(response.data, "API Response for UOMs");
        //console.log(formatted, "formatted");
        setUoms(formatted);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      dispatch({ type: "DESTROY_BACKDROP" });
    }
  };
  useEffect(() => {
    fetchUOMs();
  }, []);

  const saveNewUom = async () => {
    try {
      const newUoms = uoms.filter((uom) => uom.isNew); // Filter new UOMs
      if (newUoms.length === 0) {
        //console.log("No new UOMs to save.");
        return;
      }

      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"),
        productUOMsList: newUoms.map(({ uom, uomType, selected }) => ({
          uom: uom,
          uomType: "New",
          activated: selected,
        })),
      };

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addUOMs`; // Update the endpoint for UOMs
      const response = await axios.post(url, payload);
      fetchUOMs();
      props.setUom((prev) => !prev); 
      if (response.data?.data?.status === true) {
        //console.log("New UOMs saved successfully.");
      } else {
        console.error("Failed to save new UOMs.");
      }
    } catch (error) {
      console.error("Error saving new UOMs:", error);
    }
  };

  const deleteUom = async (uom) => {
    //console.log(uom, "Deleting UOM");
    try {
      if (uom.isNew) {
        // If the UOM is new and not yet saved, remove it from the state
        setUoms((prevUoms) => prevUoms.filter((item) => item.id !== uom.id));
      } else {
        // If the UOM is already saved, send a delete request to the API
        const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateUOMs`;
        const payload = {
          sponsorId: sponsorId,
          ecosystemId: localStorage.getItem("ecosystemId"),
          productUOMsList: [
            {
              uomID: uom.id, // Use the UOM ID
              uom: uom.uom, // UOM name
              activated: uom.selected, // Activation status
              markForDelete: true, // Mark the UOM for deletion
            },
          ],
        };
        //console.log(payload, "Payload for deleting UOM");
        const response = await axios.post(url, payload);
        fetchUOMs(); // Refresh the UOM list after deletion
        props.setUom((prev) => !prev); 
        if (response.data?.data?.status === true) {
          //console.log("UOM deleted successfully.");
        } else {
          console.error("Failed to delete UOM.");
        }
      }
    } catch (error) {
      console.error("Error deleting UOM:", error);
    }
  };
  // const handleNextClick = async () => {
  //   try {
  //     const isAnyUomSelected = uoms.filter((uom) => uom.isUpdated);

  //     // if (!isAnyUomSelected.length) {
  //     //   setErrorMessage("Please select at least one UOM."); // Show error message
  //     //   return; // Exit the function
  //     // }
  //     if (!isAnyUomSelected.length) {
  //       console.log("No updates detected. Proceeding to the next step.");
  //       props.handleNext(); // Directly move to the next tab
  //       return;
  //     }
  //     if (uoms.every((uom) => !uom.selected)) {
  //       setErrorMessage("Please enable at least one in toggle mode.");
  //       return;
  //     }
  //     setErrorMessage("");
  //     // Prepare the payload
  //     const payload = {
  //       sponsorId: 2,
  //       ecosystemId: localStorage.getItem("ecosystemId"),
  //       productUOMsList: isAnyUomSelected.map(({ id, uom, selected }) => ({
  //         uomID: id,
  //         uom: uom,
  //         activated: selected,
  //         markForDelete: false,
  //       })),
  //     };

  //     console.log(payload, "Payload for updating UOMs"); // Debugging

  //     // Call the API
  //     const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateUOMs`;
  //     const response = await axios.post(url, payload);

  //     // Log the API response for debugging
  //     console.log(response.data, "API Response");

  //     // Handle API response
  //     if (response.data?.status === true || response.data?.status === "true") {
  //       console.log("UOMs updated successfully.");
  //       await fetchUOMs(); // Wait for fetchUOMs to complete
  //       setErrorMessage(""); // Clear any previous error messages
  //       props.handleNext(); // Proceed to the next tab
  //     } else {
  //       console.error("Failed to update UOMs.");
  //       setErrorMessage("Failed to update UOMs. Please try again.");
  //     }
  //   } catch (error) {
  //     console.error("Error updating UOMs:", error);
  //     setErrorMessage(
  //       "An error occurred while updating UOMs. Please try again."
  //     );
  //   }
  // };
  const handleSaveChanges = async () => {
    try {
      const isAnyUomSelected = uoms.filter((uom) => uom.isUpdated);

      // if (!isAnyUomSelected.length) {
      //   setErrorMessage("Please select at least one UOM."); // Show error message
      //   return; // Exit the function
      // }
      if (!isAnyUomSelected.length) {
        //console.log("No updates detected. Proceeding to the next step.");
        // Directly move to the next tab
        return;
      }
      if (uoms.every((uom) => !uom.selected)) {
        setErrorMessage("Please enable at least one in toggle mode.");
        return;
      }
      setErrorMessage("");
      // Prepare the payload
      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"),
        productUOMsList: isAnyUomSelected.map(({ id, uom, selected }) => ({
          uomID: id,
          uom: uom,
          activated: selected,
          markForDelete: false,
        })),
      };

      //console.log(payload, "Payload for updating UOMs"); // Debugging

      // Call the API
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateUOMs`;
      const response = await axios.post(url, payload);

      // Log the API response for debugging
      //console.log(response.data, "API Response");

      // Handle API response
      if (response.data?.status === true || response.data?.status === "true") {
        //console.log("UOMs updated successfully.");
        await fetchUOMs(); // Wait for fetchUOMs to complete
        setErrorMessage(""); // Clear any previous error messages
      } else {
        console.error("Failed to update UOMs.");
        setErrorMessage("Failed to update UOMs. Please try again.");
      }
    } catch (error) {
      console.error("Error updating UOMs:", error);
      setErrorMessage(
        "An error occurred while updating UOMs. Please try again."
      );
    }
  };
  const handleSaveNewUom = async (index) => {
    const uom = uoms[index];
    if (!uom.uom?.trim() || savingStates[index]) return;
    setSavingStates((prev) => ({ ...prev, [index]: true }));
    const success = await saveNewUom(uom);
    if (success) {
      await fetchUOMs();
    } else {
      // Handle failure (e.g., show an error message)
      console.error("Failed to save new UOM.");
    }
    setSavingStates((prev) => ({ ...prev, [index]: false }));
  };

  // const handleToggle = (index) => {
  //   const updated = [...uoms]; // Create a shallow copy of the `uoms` array
  //   updated[index].selected = !updated[index].selected; // Toggle the `selected` property of the UOM at the given index
  //   setUoms(updated); // Update the state with the modified array
  //   setIsUpdated(true); // Optional: Track changes if needed
  // };
  const handleToggle = (index) => {
    const updated = [...uoms]; // Create a shallow copy of the `uoms` array
    updated[index].selected = !updated[index].selected; // Toggle the `selected` property of the UOM at the given index
    updated[index].isUpdated = true; // Mark the UOM as changed
    setUoms(updated); // Update the state with the modified array
    setIsUpdated(true); // Optional: Track changes if needed
  };

  const handleNameChange = (index, value) => {
    const updated = [...uoms]; // Create a shallow copy of the `uoms` array
    updated[index].uom = value; // Update the `uom` property of the UOM at the given index
    setUoms(updated); // Update the state with the modified array
    //console.log(updated, "Updated UOMs after name change"); // Debugging
  };
  const handleDelete = (index) => {
    const newUoms = uoms.filter((_, i) => i !== index);
    setUoms(newUoms);
  };

  const handleAddUom = () => {
    // const nextId = (uoms.length + 1).toString().padStart(2, "0");
    setUoms([
      ...uoms,
      {
        // id: nextId,
        uom: "",
        uomType: "New",
        selected: false,
        isNew: true,
      },
    ]);
  };

  const handleCancel = (index) => {
    const updatedUoms = uoms.filter((_, i) => i !== index); // Remove the UOM at the given index
    setUoms(updatedUoms); // Update the state with the new list
    //console.log(updatedUoms, "UOMTab", "Updated UOMs after cancel"); // Log the updated UOMs
  };
  const handleResetChanges = () => {
    if (isUpdated) {
      fetchUOMs(); // Re-fetch the UOM list
      setIsUpdated(false); // Reset the update state
      setErrorMessage(""); // Clear any error messages
    }
  };

  return (
    <div
      className={classes.container}
      style={{ display: "flex", flexDirection: "column", gap: "24px" }}
    >
      {/* Table and Buttons Section */}
      <div style={{ display: "flex", gap: "40px", alignItems: "flex-start" }}>
        <Table className={`${classes.table} default-table-styles`}>
          <TableHead>
            <TableRow>
              <TableCell className={`${classes.headerCell} default-table-styles`}>Selection</TableCell>
              <TableCell className={`${classes.headerCell} default-table-styles`}>UOM</TableCell>
              <TableCell className={`${classes.headerCell} default-table-styles`}>UOM ID</TableCell>
              <TableCell className={`${classes.headerCell} default-table-styles`}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                    }}
                  >
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60px",
                      backgroundColor: "#ffecec",
                      color: "#b00020",
                      border: "1px solid #ff9999",
                    }}
                  >
                    <Typography>{error}</Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              uoms.map(
                (uom, index) => (
                  
                  (
                    <TableRow key={uom.id}>
                      <TableCell className={classes.bodyCell}>
                        <Switch
                          checked={uom.selected}
                          onChange={() => handleToggle(index)}
                          classes={{ switchBase: classes.switchBase }}
                          disabled={!canEdit}
                        />
                      </TableCell>
                      <TableCell className={classes.bodyCell}>
                        {uom.isNew ? (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <TextField
                              placeholder="Type Text Here"
                              value={uom.uom || ""} // Bind the `uom` property to the input field
                              onChange={(e) =>
                                handleNameChange(index, e.target.value)
                              } // Call handleNameChange on input change
                              onBlur={(e) => {
                                const { value } = e.target;
                                // Trim leading and trailing spaces for string values
                                if (
                                  typeof value === "string" &&
                                  value.trim() !== value
                                ) {
                                  handleNameChange(index, value.trim());
                                }
                              }}
                              className={classes.textField}
                              variant="outlined"
                              inputProps={{
                                onBeforeInput: (e) => {
                                  const allowedChars = /^[a-zA-Z\s]+$/;
                                  if (!allowedChars.test(e.data)) {
                                    e.preventDefault();
                                  }
                                },
                              }}
                            />
                            <div className={classes.inlineActions}>
                              <IconButton
                                onClick={() => handleCancel(index)}
                                className={classes.iconBtn}
                              >
                                <CancelIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                onClick={() => handleSaveNewUom(index)}
                                className={classes.iconBtn}
                                disabled={
                                  !uoms[index].uom?.trim() ||
                                  uoms.some(
                                    (item, i) =>
                                      i !== index &&
                                      item.uom?.trim()?.toLowerCase() === uoms[index].uom?.trim()?.toLowerCase()
                                  ) || savingStates[index]
                                }
                              >
                                <SaveIcon fontSize="small" />
                              </IconButton>
                            </div>
                          </div>
                        ) : (
                          uom.uom
                        )}
                      </TableCell>
                      <TableCell className={classes.bodyCell}>
                        {uom.id}
                      </TableCell>
                      <TableCell className={classes.bodyCell}>
                        {canEdit && (uom.isNew == true ||
                          (uom.uomType === "New" &&
                            uom.lastUpdatedBy !== "support@schrocken.com")) && (
                          <IconButton
                            aria-label="delete"
                            onClick={() => deleteUom(uom)}
                          >
                            <DeleteIcon className={classes.deleteIcon} />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  )
                )
              )
            )}
          </TableBody>
        </Table>
        <div
          className={classes.footer}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px", // Space between buttons
            marginTop: "16px", // Space between table and buttons
            marginLeft: "16px", // Space between table and buttons
          }}
        >
          <Button
            className={classes.saveButton}
            type="button"
            onClick={handleSaveChanges}
            disabled={!isUpdated || !canEdit}
            style={{
    
    opacity: !isUpdated || !canEdit ? 0.7 : 1, // Fade out when disabled
    color: "#fff", 
  }}
          >
            Save Selection
          </Button>
          <Button
            className={classes.resetChangesButton}
            type="button"
            onClick={handleResetChanges}
             disabled={!isUpdated || !canEdit} // or whatever your "no changes" condition is
  style={{
    opacity: !isUpdated || !canEdit ? 0.8 : 1, // Fade out when disabled
  }}
          >
            Reset Selection
          </Button>
        </div>
      </div>
      {errorMessage && (
        <div style={{ color: "red" }} className="error-message">
          {errorMessage}
        </div>
      )}
      {canEdit && (
        <Button
          variant="outlined"
          onClick={handleAddUom}
          className={classes.addButton}
        >
          <span className={classes.addIconCircle}>+</span>
          Add New UOM
        </Button>
      )}
    </div>
  );
};

export default UOMTab;
